// extracted by mini-css-extract-plugin
export default {"root":"styles_root__7okcB","content":"styles_content__GNXmY","description":"styles_description__MJqi4","inputRow":"styles_inputRow__oTh2b","form":"styles_form__JKKM3"};